import React from 'react';
import Logo from '../media/Transparent-Star-Only-Logo.png';

function CookiePolicy() {
  return (
    <div
      className="min-h-screen py-12 px-4 sm:px-6 lg:px-8"
      style={{ background: 'linear-gradient(180deg, #F4F1FF 0%, #FFFFFF 60%)' }}
    >
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-3xl p-8 md:p-12 border border-[#EDE7FF]">
        {/* Brand header */}
        <div className="flex items-center gap-4 mb-8">
          <img src={Logo} alt="Nova Learning" className="h-12 w-auto" />
          <div className="h-8 w-px bg-[#EDE7FF]" />
          <span
            className="text-[#765AD8] text-lg font-semibold"
            style={{ fontFamily: 'Fredoka, sans-serif' }}
          >
            Nova Learning
          </span>
        </div>

        <h1
          className="text-3xl md:text-4xl font-bold text-[#2F1E6B] mb-8"
          style={{ fontFamily: 'Fredoka, sans-serif' }}
        >
          Privacy and Cookie Policy
        </h1>

        <div className="prose prose-lg max-w-none" style={{ fontFamily: 'Poppins, sans-serif' }}>
          <p className="text-gray-700 mb-6">
            This Privacy and Cookie Policy explains how Nova Learning Ltd ("we", "us", "our") collects, uses, and protects your personal information when you visit our website or use our services.
          </p>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>1. Scope</h2>
          <p className="text-gray-700 mb-6">
            This policy applies to users of the Nova Learning website and services. By using our site, you consent to the practices described in this policy.
          </p>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>2. Data We Collect</h2>
          <p className="text-gray-700 mb-4">
            We may collect the following types of personal data:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-6 ml-4 space-y-2 marker:text-[#BAE066]">
            <li>Contact information (such as your name, email address, and phone number)</li>
            <li>Account details you provide when signing up for a free trial or registering interest</li>
            <li>Technical data such as your IP address and browser or device type</li>
            <li>Usage data such as pages visited, time spent on the site, and interactions with features</li>
          </ul>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>3. How We Use Your Data</h2>
          <p className="text-gray-700 mb-4">
            We process personal data to:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-6 ml-4 space-y-2 marker:text-[#BAE066]">
            <li>Provide access to our platform and services</li>
            <li>Respond to enquiries or support requests</li>
            <li>Improve our platform and enhance your user experience</li>
            <li>Share relevant updates, offers, or service communications</li>
            <li>Deliver relevant advertisements, including to similar audiences via privacy-safe tools</li>
          </ul>
          <p className="text-gray-700 mb-6">
            We process this data based on your consent, our legitimate interests, or where necessary to perform a contract with you, in accordance with Article 6 of the UK GDPR.
          </p>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>4. Cookies</h2>
          <p className="text-gray-700 mb-4">
            We use cookies and similar technologies to:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-6 ml-4 space-y-2 marker:text-[#BAE066]">
            <li>Ensure the website operates correctly and securely</li>
            <li>Analyse how visitors interact with the site</li>
            <li>Personalise your experience and improve performance</li>
            <li>Show relevant advertisements about Nova Learning</li>
          </ul>
          <p className="text-gray-700 mb-6">
            Some cookies are essential and do not require your consent. Others, such as analytics or marketing cookies, will only be used with your permission. You can update your cookie preferences at any time through our cookie settings.
          </p>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>5. Sharing and Third Parties</h2>
          <p className="text-gray-700 mb-4">
            We do not sell your personal data. We only share it with trusted service providers who process data on our behalf under strict data protection obligations. These may include:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-6 ml-4 space-y-2 marker:text-[#BAE066]">
            <li>Hosting and cloud infrastructure providers</li>
            <li>Analytics and performance tools</li>
            <li>Advertising and marketing platforms (for retargeting or audience matching)</li>
          </ul>
          <p className="text-gray-700 mb-6">
            All partners are required to handle your data securely and lawfully.
          </p>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>6. Your Rights</h2>
          <p className="text-gray-700 mb-4">
            Under the UK General Data Protection Regulation (UK GDPR), you have the right to:
          </p>
          <ul className="list-disc list-inside text-gray-700 mb-6 ml-4 space-y-2 marker:text-[#BAE066]">
            <li>Access the personal data we hold about you</li>
            <li>Request corrections or updates to inaccurate information</li>
            <li>Request deletion of your data in certain circumstances</li>
            <li>Withdraw your consent at any time (where processing is based on consent)</li>
            <li>Object to or restrict certain types of processing</li>
            <li>Lodge a complaint with the Information Commissioner's Office (ICO)</li>
          </ul>
          <p className="text-gray-700 mb-6">
            To exercise any of these rights, please contact us at <a href="mailto:info@novalearning.co.uk" className="text-[#765AD8] hover:text-[#2F1E6B] underline font-medium">info@novalearning.co.uk</a>.
          </p>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>7. Data Retention</h2>
          <p className="text-gray-700 mb-6">
            We retain your personal data only for as long as necessary to fulfil the purposes outlined in this policy, unless a longer retention period is required by law.
          </p>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>8. International Transfers</h2>
          <p className="text-gray-700 mb-6">
            Where personal data is transferred outside the UK (for example, to cloud providers or analytics partners), we ensure that appropriate safeguards are in place, such as standard contractual clauses or adequacy decisions.
          </p>

          <h2 className="text-2xl font-semibold text-[#2F1E6B] mt-8 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>9. Updates to This Policy</h2>
          <p className="text-gray-700 mb-6">
            We may update this Privacy and Cookie Policy from time to time to reflect changes in our services or legal requirements. Any changes will be posted on this page with an updated effective date.
          </p>

          <p className="text-[#2F1E6B] font-semibold mb-8">
            Effective Date: October 2025
          </p>

          <hr className="my-8 border-0 h-px bg-gradient-to-r from-[#BAE066] via-[#765AD8] to-[#FD8C7C]" />

          <div className="text-center text-gray-500 text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>
            <p>© {new Date().getFullYear()} Nova Learning Ltd. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookiePolicy;
